import { makeEnvironmentProviders } from '@angular/core';

export * from './models';
export * from './pages';
export * from './services';

export const provideLocations = () => {
  return makeEnvironmentProviders([
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (locations: LocationService) => {
    //     return () => locations.populate();
    //   },
    //   deps: [LocationService],
    //   multi: true,
    // },
  ]);
};
